module.exports = __webpack_public_path__ + "img/error.cc9a0617.svg";